"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wheelScrollDeltaToCount = void 0;
var wheelScrollDeltaToCount = function (deltaY) { return -deltaY / 50; };
exports.wheelScrollDeltaToCount = wheelScrollDeltaToCount;
